// extracted by mini-css-extract-plugin
export default {"error":"Sk6LS","icon":"PKo8V","title":"EOzbx","text":"Gza8q","button":"EVYqN"};